import { frontendURL } from 'dashboard/helper/URLHelper';
import SettingsWrapper from 'dashboard/routes/dashboard/settings/SettingsWrapper.vue';
import AutomationEnhanced from './automation/Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/automate'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          redirect: to => {
            return { name: 'automate_list', params: to.params };
          },
        },
        {
          path: 'list',
          name: 'automate_list',
          component: AutomationEnhanced,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
